export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7760.76755452.jpg";